import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IllustrataService } from '@Services/case/illustrata.service';

@Component({
    selector: 'illustrata-dialog-component',
    host: { 'class': 'dialog-iframe-content' },    
    template: `<mat-dialog-content style="max-height: unset; flex: 1 1 auto;"><div style="height: 100%;overflow-y: hidden">
  <iframe style="width: 100%; height: 100%" [src]="frameUrl" title="Illustrata">
  </iframe> </div> </mat-dialog-content><mat-dialog-actions style="justify-content: flex-end;">
  <button matButton (click)="close()">Close</button>
</mat-dialog-actions>
`,
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule]
})


export class IllustrataDialogComponent implements OnInit{
  illustrataComplete: boolean = false;
  @ViewChild('iframe', {static: false}) iframe: ElementRef | undefined;
  @ViewChild('embedContainer', { static: false }) embedContainer: ElementRef<HTMLDivElement> | undefined;  

  frameUrl: SafeResourceUrl | undefined;

  constructor(
    public dialog: MatDialog,
    private readonly sanitized: DomSanitizer,
    private readonly illustrataService: IllustrataService,
    @Inject(MAT_DIALOG_DATA) public data) {
  }
  ngOnInit(): void {
    this.frameUrl = this.data.frameUrl;
    if (this.isValidUrl(this.data.frameUrl)) {
          this.frameUrl = this.sanitized.bypassSecurityTrustResourceUrl(this.data.frameUrl);
          window.addEventListener('message', this.handleBrowserMessage.bind(this));
      } else {
          console.error('Invalid URL provided:', this.data.frameUrl);
          this.frameUrl = undefined;
      }
  }

  close() {
      this.dialog.closeAll();    
  }

  private isValidUrl(url: string): boolean {
      try {
          const urlObj = new URL(url);
          // Only allow http and https protocols
          return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
      } catch {
          return false;
      }
  }

   handleBrowserMessage(event: any) {
        if (event == null || event.data == null) { return; }

        try {
            const messageData = event.data;
            if (messageData.type !== 'illustrata:result-ready') { return; }

            this.illustrataComplete = true;
            this.handleCallBack(messageData);
        } catch (error) {
            // non-json payload, someone else's message
        }
    }

    handleCallBack(response: any) {
      this.illustrataService.submitCallback(this.data.caseIntegrationQueueId, response).subscribe(() => {});
    }
}
